/**
 * The advertised base plans, as the pricing cards present them.
 *
 * These mirror the price functions in Pricing.jsx (calculateStandardPrice and
 * friends). They are NOT read from the server: the onboarding guide quotes a
 * price before the user has opened the pricing page at all, and a second source
 * of truth that drifts is worse than a hardcoded one that is reviewed.
 *
 * Change a price here and in Pricing.jsx together.
 *
 * NOTE: unlike the Shopify app's copy, there is no trial here. Stripe checkout
 * builds its session from inline price_data with no
 * subscription_data.trial_period_days, so nothing in this app may promise one.
 */
export const BASE_PLANS = {
  standard: {
    key: 'standard', nameKey: 'standard_plan', billingType: 1, price: 24.99, staff: 5,
    // Three things each pricing card already lists, as existing translation keys.
    highlightKeys: ['scheduling_shifts', 'payroll_management', 'detailed_reporting'],
  },
  premium: {
    key: 'premium', nameKey: 'premium_plan', billingType: 2, price: 39.99, staff: 10,
    highlightKeys: ['time_off_task_list_management', 'payroll_management', 'detailed_reporting'],
  },
  enterprise: {
    key: 'enterprise', nameKey: 'enterprise_plan', billingType: 4, price: 199.99, staff: 100,
    highlightKeys: ['selfie_verified_time_tracking', 'payroll_management', 'detailed_reporting'],
  },
};

/** Team-size answers the guide offers, and the plan whose cap covers each. */
export const TEAM_SIZES = [
  { value: 'solo', labelKey: 'onboarding_team_size_solo', min: 1, plan: null },
  { value: '2-5', labelKey: 'onboarding_team_size_2_5', min: 2, plan: 'standard' },
  { value: '6-10', labelKey: 'onboarding_team_size_6_10', min: 6, plan: 'premium' },
  { value: '11-100', labelKey: 'onboarding_team_size_11_100', min: 11, plan: 'enterprise' },
  { value: '100+', labelKey: 'onboarding_team_size_100_plus', min: 101, plan: 'enterprise' },
];

export const formatUsd = (amount) => `$${Number(amount).toFixed(2)}`;
